import COLORS from 'const/colors';

const CloseYellow = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 2.66667L2.66663 13.3333"
      stroke={COLORS.TEXT.HOLA_YELLOW_3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66663 2.66667L13.3333 13.3333"
      stroke={COLORS.TEXT.HOLA_YELLOW_3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CloseYellow;
